async function downloadEntityFiles(file) {
  const targetUrl = `${process.env.CMS_URL}${file.url}`;

  try {
    let a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    a.href = targetUrl;
    a.target = "_blank";
    a.download = file.name;
    a.click();
    // window.URL.revokeObjectURL(url);
  } catch (e) {
    console.log(e);
  }
}

export default downloadEntityFiles;
